import { Button } from "@/components/ui/button";
import { useTranslation } from 'react-i18next';

interface ConfigurationErrorProps {
  error: string;
  onRetry: () => void;
  title?: string;
}

export function ConfigurationError({ 
  error, 
  onRetry,
  title
}: ConfigurationErrorProps) {
  const { t } = useTranslation('business', { keyPrefix: 'communication' });
  const defaultTitle = t('configurationError');
  
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6">
      <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mb-4">
        <span className="text-2xl">⚠️</span>
      </div>
      <h3 className="text-lg font-semibold text-slate-900 mb-2">{title || defaultTitle}</h3>
      <p className="text-slate-600 text-center max-w-sm mb-6">{error}</p>
      <Button onClick={onRetry} className="px-6">
        {t('tryAgain')}
      </Button>
    </div>
  );
} 